import { z } from 'zod'

import { UserIdZ } from '@/types/common'
import { SearchIdZ } from '@/types/search'

import { CreateJobResponseZ, getJobGroupResultResponseZ } from '../job'
import { FlightFareGroupKeyZ, FlightIdentifierZ, FlightOptionKeyZ } from './common'
import { FlightBookingOptionZ } from './search'

export const FlightFaresPricingCreateJobRequestZ = z.array(
	z.strictObject({
		fare_group_key: FlightFareGroupKeyZ,
		flight_option_keys: z.array(FlightOptionKeyZ),
		flight_identifier: FlightIdentifierZ,
		user_id: UserIdZ,
		search_id: SearchIdZ,
		fare_families: z.boolean().optional(),
	}),
)

export type FlightFaresPricingCreateJobRequest = z.infer<typeof FlightFaresPricingCreateJobRequestZ>

export const FlightFaresPricingCreateJobResponseZ = CreateJobResponseZ

export type FlightFaresPricingCreateJobResponse = z.infer<typeof FlightFaresPricingCreateJobResponseZ>

export const FlightFaresPricingJobResultResponseZ = getJobGroupResultResponseZ(
	z.strictObject({
		fare_groups: z.array(FlightBookingOptionZ),
		session_ids: z.unknown(),
	}),
)

export type FlightFaresPricingJobResultResponse = z.infer<typeof FlightFaresPricingJobResultResponseZ>
